export default {
    TEXT_RESPONSE: 'TextResponse',
    IMAGE_RESPONSE: 'ImageResponse',
    VIDEO_RESPONSE: 'VideoResponse',
    CAROUSEL_RESPONSE: 'CarouselResponse',
    CARD_RESPONSE: 'ButtonCardResponse',
    SCHEMA_FORM_RESPONSE: 'SchemaForm',
    SURVEY_FORM_RESPONSE: 'SurveyForm',
    HUMAN_HANDOFF_FORM: 'HumanHandoffForm',
    FILE_ATTACHMENT: 'FileAttachment',
    MULTI_SOURCE: 'MultiSource',
    LLM_SCHEMA_FORM_RESPONSE: 'LLMSchemaForm',
    SECURE_FORM_RESPONSE: 'SecureForm'
  }
